import React from 'react';
import { render, unmountComponentAtNode, createPortal } from 'react-dom';
import styles from './index.less';
import { Dialog, DialogConfig, DialogItem } from './dialog';
export * from './dialog';

function getDialogRoot() {
  let root = document.getElementById('dialog_root');
  if (!root) {
    root = document.createElement('div');
    // root.id = 'dialog_root';
    root.setAttribute('id', 'dialog_root');
    root.classList.add(styles.dialogRoot);
    document.body.appendChild(root);
  }
  return root;
}
const dialogs: DialogItem<any, any>[] = [];
function renderDialogs() {
  const content = dialogs.map((c) => {
    const Comp = c.component;
    if (Comp) {
      return (
        <div key={c.instance.id} className={styles.dialogContainer}>
          <Comp dialog={c.instance}></Comp>
        </div>
      );
    }
    return null;
  });
  render((
    <>{content}</>
  ), getDialogRoot());
}
function cleanDialogs() {
  dialogs.splice(0, dialogs.length);
  unmountComponentAtNode(getDialogRoot());
}

export function testDialog() {
  const temp = render(<div className={styles.dialogContainer}>test</div>, getDialogRoot());
  console.log('***temp', temp);
}

export function OpenDialog<R = void, D = void>(
  Comp: (props: { dialog?: Dialog<R, D>, [key: string]: any } | any) => React.ReactElement,
  config?: DialogConfig<R, D>
) {
  const dialog = {
    instance: new Dialog<R, D>(config),
    component: Comp
  };
  dialogs.push(dialog);
  renderDialogs();
  dialog.instance.afterClosed().finally(() => {
    dialogs.splice(dialogs.indexOf(dialog), 1);
    renderDialogs();
  }).catch((err) => {
    console.error(err);
  });
  return dialog.instance;
}
